export const getDomain = () => {
	if (typeof window === "undefined") return "";
	return window.location.origin;
};

export const safelyNavigateWithPTRT = (url: string, ptrt?: string) => {
	if (typeof window !== "undefined") {
		window.location.href = `${url}?ptrt=${ptrt || window.location.pathname}`;
	}
};
